/* Which hours a report counts (owner 10-19: reports are built from approved data).

   v2 recap gives every day `approved_hours` (Deleted rows and automatic clock-outs still waiting for
   their correction left out) and `unverified_entries`. Every report reads the recap from v2
   (./recapApi.js). A recap without those fields (an older gateway) keeps the old rules: the PDFs count
   Submitted days only, the on-screen table and modals count every day. */

export const timeToSeconds = (t) => {
  if (!t || typeof t !== "string") return 0;
  const [h = 0, m = 0, s = 0] = t.split(":").map(Number);
  return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
};

export const hasApprovedHours = (day) => !!day && typeof day.approved_hours === "string";

// Summary PDF / report modal
export const reportDaySeconds = (day) => {
  if (!day) return 0;
  if (hasApprovedHours(day)) return timeToSeconds(day.approved_hours);
  return day.status === "Submitted" ? timeToSeconds(day.total_hours || "0:00:00") : 0;
};

// On-screen Reports table: approved hours in every view (All, Pending, Submitted: owner 10-19,
// review 10-19); only the Deleted filter shows the deleted rows' recorded hours, which no report counts.
export const tableDaySeconds = (day, approvedOnly) => {
  if (!day) return 0;
  if (approvedOnly && hasApprovedHours(day)) return timeToSeconds(day.approved_hours);
  return timeToSeconds(day.total_hours || "0:00:00");
};

export const isUnverifiedDay = (day) => Number(day?.unverified_entries || 0) > 0;

export const unverifiedDayCount = (recap) => (Array.isArray(recap) ? recap.filter(isUnverifiedDay).length : 0);

// Employee / day modals (screen + their PDFs): every use of day.total_hours shows the approved hours
// (review 10-19); the recorded hours stay in recorded_total_hours.
export const withReportHours = (recap) =>
  (Array.isArray(recap) ? recap : []).map((day) =>
    hasApprovedHours(day)
      ? { ...day, recorded_total_hours: day.total_hours, total_hours: day.approved_hours }
      : day
  );
